// extracted by mini-css-extract-plugin
export default {"overlay":"LoadingSpinner_overlay__rBm1x","spinnerContainer":"LoadingSpinner_spinnerContainer__sTtW7","message":"LoadingSpinner_message__M0+uW"};